export default __webpack_public_path__ + "static/media/Founders-back.8abba29e.jpg";